<template>
	<div>
		<div class="main">
			<img :src="getMineListAll.aboutText" class="content">
		</div>
	</div>
</template>

<script>
	import { appCAboutList } from "@/api/mineInfo.js"
	let _self;
	export default {
		name: "",
		data() {
			return {
				//关于我们内容
				getMineListAll:[],
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			//获取关于我们信息
			_self.getMineInfoList();
		},
		// 方法集
		methods: {
			getMineInfoList(){
				appCAboutList().then(res=>{
					// console.log("关于我们",res);
					if(res.data&&res.code==200){
						_self.getMineListAll=res.data.list[0];
					}
				})
			}
		},
		// 组件集
		components: {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		// 过滤器
		filters: {

		},
		// 实例销毁
		destroyed() {

		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			// next();
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
	}
</script>

<style scoped>
	.main {
		width: 100%;
		background-color: #FFFFFF;
		padding: 40px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.content {
		width: 100%;
		height: 100%;
		display: block;
		padding-bottom: 45px;
		box-sizing: border-box;
	}
</style>
